import type { ColorNamePair } from './colorNamesPool'
import type { Player } from './Player.type'
import { PlayerGameStatus } from './PlayerGameStatus'
import type { PlayerId } from './PlayerId'
import { PlayerKind } from './PlayerKind.enum'
import { PlayerTurnStatus } from './PlayerTurnStatus'

const playerDefaults = {
  kind: PlayerKind.OpenSlot,
  money: 0,
  turn_status: PlayerTurnStatus.Waiting,
  dname: null,
  game_status: PlayerGameStatus.Active,
} as const

export default function createBlankPlayer(id: PlayerId, colorNamePair: ColorNamePair): Player {
  const player : Player = {
    id,
    ...playerDefaults,
    color1: colorNamePair.color1,
    color2: colorNamePair.color2,
    dname_placeholder: colorNamePair.dname,
  }
  return player
}
